import { format } from 'date-fns';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  title: string;
  date?: string | null;
  isCompleted: boolean;
  isActive: boolean;
  isRejected: boolean;
  organizationNote?: string;
};
export const ClientRequestDeliveryStep: FC<Props> = ({
  organizationNote,
  title,
  date,
  isCompleted,
  isActive,
  isRejected,
}) => {
  const { t } = useTranslation();
  const formattedDate = useMemo(() => {
    if (!date) return '';
    const dateConverted = new Date(Date.parse(date));
    return format(dateConverted, 'dd/MM/yyyy HH:mm');
  }, [date]);

  return (
    <div
      className={`flex items-start space-x-4 ${
        isRejected ? 'text-red-500' : isActive ? 'text-blue-600' : isCompleted ? 'text-gray-500' : 'text-gray-400'
      }`}
    >
      {/* Step Icon */}
      <div className="flex-shrink-0">
        {isCompleted && !isRejected ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-green-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        ) : isActive ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-blue-600 animate-pulse"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <circle cx="12" cy="12" r="10" stroke="currentColor" />
            <circle cx="12" cy="12" r="6" fill="currentColor" />
          </svg>
        ) : isRejected ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <circle cx="12" cy="12" r="10" stroke="currentColor" />
          </svg>
        )}
      </div>
      {/* Step Content */}
      <div>
        <p className={`font-medium ${isRejected ? 'text-red-500' : ''}`}>{t(`client-delivery-requests.${title}`)}</p>
        <p className="text-sm">{formattedDate}</p>
        {title === 'REJECTED_BY_AGENCY' && (
          <p className="text-sm text-gray-400">
            <strong>La raison du refus est :</strong>
            <br />
            {organizationNote}
          </p>
        )}
      </div>
    </div>
  );
};
